import React, { ReactNode } from "react"
import classNames from "classnames";

const FormWrapper = ({children, classes}: {children: ReactNode, classes?: string}) => {

  const isNativeAndroid = document?.userPlatform === "native_android";
  const isWebAndroid = document?.userPlatform === "web_android";
  const isWebIos = document?.userPlatform === "web_ios";
  const isNativeIos = document?.userPlatform === "native_ios";
  const isWebOther = document?.userPlatform === "web_other";

  return(
    <div className={classNames("tw-flex tw-flex-col tw-w-full", {
      "tw-h-[95%]" : isWebOther,
      "tw-h-[90%]" : isNativeAndroid, 
      "tw-h-[88%]" : isWebAndroid || isNativeIos, 
      "tw-h-[78%]" : isWebIos, 
      // use 50% as a default if document.userPlatform is somehow unrecognised
      "tw-h-[50%]" : (!isWebAndroid && !isNativeAndroid && !isNativeIos && !isWebIos && !isWebOther),
      [`${classes}`]: classes})}>
      {children}
    </div>
  )
}

export default FormWrapper